const cardItems = [
  {
    title: '久久视频 vs 芒果视频：如何选择适合你的平台',
    desc: '两大热门在线视频平台各有千秋。久久视频以海量影视资源与快速更新著称，芒果视频则在独家综艺和自制内容方面独具优势。本文从内容类型、画质体验、更新频率三个维度为你详细对比。',
    tag: '对比评测',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20comparison%20layout%20of%20two%20video%20streaming%20platforms%2C%20modern%20UI%20design%20elements%2C%20warm%20versus%20cool%20color%20scheme%2C%20professional%20review%20style%2C%20clean%20minimalist%20background&width=600&height=400&seq=card-01-2026&orientation=landscape',
  },
  {
    title: '2026年在线视频平台趋势展望',
    desc: '高清视频网站持续增长，AI推荐技术日益成熟。从97视频的个性化算法到蓝莓视频的超清画质升级，在线视频行业正迎来新一轮创新浪潮。青青草视频将持续跟踪行业动态。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=A%20futuristic%20digital%20media%20trend%20visualization%20with%20glowing%20data%20charts%20and%20streaming%20icons%2C%20warm%20coral%20accents%2C%20modern%20tech%20aesthetic%2C%20clean%20background%2C%20professional%20analytics%20theme&width=600&height=400&seq=card-02-2026&orientation=landscape',
  },
  {
    title: '移动观影指南：手机看视频的正确姿势',
    desc: '越来越多用户选择在手机上观看在线视频。青青草视频整理了移动端观影的实用技巧，包括各平台APP特色对比、流量节省方案和最佳观看设置。',
    tag: '使用指南',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20video%20streaming%20app%20interface%20in%20a%20cozy%20setting%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20lifestyle%2C%20clean%20composition%2C%20mobile%20entertainment%20theme&width=600&height=400&seq=card-03-2026&orientation=landscape',
  },
  {
    title: '从丝瓜视频到糖心视频：小众平台的独特魅力',
    desc: '除了主流视频网站，丝瓜视频和糖心视频等特色平台也在各自领域深耕。丝瓜视频覆盖全品类内容，糖心视频则专注个性化推荐与社区互动，为用户提供了差异化的观影选择。',
    tag: '平台探索',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20collage%20of%20niche%20video%20platform%20interfaces%20with%20unique%20design%20elements%2C%20warm%20and%20vibrant%20color%20palette%2C%20community-focused%20layout%2C%20modern%20digital%20art%20style&width=600&height=400&seq=card-04-2026&orientation=landscape',
  },
  {
    title: '安全上网须知：视频网站使用注意事项',
    desc: '青青草视频提醒广大用户：请通过正规渠道访问在线视频平台，注意保护个人隐私信息。我们收录的所有平台入口均经过安全审核，但各平台的具体内容请以官方发布为准。',
    tag: '安全指南',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20security%20concept%20with%20shield%20icon%20and%20lock%20symbols%2C%20warm%20reassuring%20color%20tone%2C%20clean%20professional%20design%2C%20online%20safety%20theme%2C%20minimalist%20background&width=600&height=400&seq=card-05-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-article-line"></i>
            精选推荐
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            精选内容与实用指南
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            深度文章和使用指南，让您更好地享受在线视频体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 max-w-3xl mx-auto">
          {cardItems.slice(3).map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}